import { render } from "./Navbar.vue?vue&type=template&id=b8fb7574&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=b8fb7574&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1372789139/src/portfolio-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8fb7574"]])

export default __exports__